import api from './api.service'

export const changeLogService = {
    list,
    save,
    update,
    _delete
};

const BASE_URL = '/changeLogs'

function list(max) {
    return api.get(BASE_URL, {max : max || 100})
}

function save(changeLog) {
    return api.post(BASE_URL, changeLog)
}

function update(id, changeLog) {
    return api.put(BASE_URL + "/" + id, changeLog)
}

function _delete(id) {
    return api.delete(BASE_URL + "/" + id)
}
